import { Suspense, lazy } from 'react';

import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';
import { Routes, Route } from 'react-router';

import { LoadingScreen } from '@/components';
import { RootLayout } from '@/layouts';
import { APP_ROUTES } from '@/router/routesEnum';

const LandingPage = lazy(() => import('@/layouts/RootLayout/LandingPage'));
const Page404 = lazy(() => import('@/pages/Page404'));

export function Router() {
  return (
    <Suspense fallback={<LoadingScreen />}>
      <Routes>
        <Route element={<RootLayout />}>
          <Route index path={APP_ROUTES.ROOT} element={<LandingPage />} />
          <Route
            index
            path={APP_ROUTES.AIRES_METODOLOGY}
            element={
              <Typography variant="h3">
                Aires Methodology page <Chip label="Soon" color="primary" />
              </Typography>
            }
          />
          <Route
            index
            path={APP_ROUTES.LENDING_METODOLOGY}
            element={
              <Typography variant="h3">
                Lending Methodology page <Chip label="Soon" color="primary" />
              </Typography>
            }
          />
          <Route
            index
            path={APP_ROUTES.COMMUNITY_METODOLOGY}
            element={
              <Typography variant="h3">
                Community Methodology page <Chip label="Soon" color="primary" />
              </Typography>
            }
          />
        </Route>
        <Route path="*" element={<Page404 />} />
      </Routes>
    </Suspense>
  );
}
